__turbopack_context__.v({
  "background-white": "BlockDownloadableResources-module-scss-module__sS0yzq__background-white",
  "branding": "BlockDownloadableResources-module-scss-module__sS0yzq__branding",
  "download": "BlockDownloadableResources-module-scss-module__sS0yzq__download",
  "downloadIconWrapper": "BlockDownloadableResources-module-scss-module__sS0yzq__downloadIconWrapper",
  "downloadList": "BlockDownloadableResources-module-scss-module__sS0yzq__downloadList",
  "downloadTitle": "BlockDownloadableResources-module-scss-module__sS0yzq__downloadTitle",
  "flushBottom": "BlockDownloadableResources-module-scss-module__sS0yzq__flushBottom",
  "flushTop": "BlockDownloadableResources-module-scss-module__sS0yzq__flushTop",
  "headline": "BlockDownloadableResources-module-scss-module__sS0yzq__headline",
  "info": "BlockDownloadableResources-module-scss-module__sS0yzq__info",
  "inner": "BlockDownloadableResources-module-scss-module__sS0yzq__inner",
  "innerDownload": "BlockDownloadableResources-module-scss-module__sS0yzq__innerDownload",
  "resource": "BlockDownloadableResources-module-scss-module__sS0yzq__resource",
  "resourceIconBox": "BlockDownloadableResources-module-scss-module__sS0yzq__resourceIconBox",
  "resourceIconWrapper": "BlockDownloadableResources-module-scss-module__sS0yzq__resourceIconWrapper",
  "resourceTitle": "BlockDownloadableResources-module-scss-module__sS0yzq__resourceTitle",
  "resources": "BlockDownloadableResources-module-scss-module__sS0yzq__resources",
  "root": "BlockDownloadableResources-module-scss-module__sS0yzq__root",
  "tips": "BlockDownloadableResources-module-scss-module__sS0yzq__tips",
});
